// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'
import styles from './ScatterPlot.module.scss'
import { useTooltip } from 'hooks/useTooltip'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'
import { Box } from 'components/layout/Box/Box'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { lowercaseFirstLetter } from 'utils/stringFormat'

// Threshold values for match scores (0-100 scale)
// High: 70-100, Medium: 50-70, Low: 0-50
export const highValueLimit = 70
export const mediumValueLimit = 50

const Dot = ({ x, y, description, area, key }) => {
  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: 'bottom' })

  return (
    <>
      <div
        className={cx(styles.dot, {
          [styles.green]: (x + y) / 2 > highValueLimit,
          [styles.yellow]:
            highValueLimit >= (x + y) / 2 && (x + y) / 2 > mediumValueLimit,
          [styles.red]: (x + y) / 2 <= mediumValueLimit,
        })}
        {...{
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        }}
        key={key}
        style={{
          left: `calc(${y}% - 8px)`,
          bottom: `calc(${x}% - 8px)`,
        }}
      ></div>
      <TetherPortal isOpen={isToggled}>
        <Box
          align="center"
          className={styles.message}
          justify="center"
          ref={floating}
          role="status"
          style={floatingStyle}
        >
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <Box
            align="center"
            className={styles.content}
            direction="column"
            justify="center"
            role="tooltip"
          >
            <div>{`${area} - ${lowercaseFirstLetter(description)}`}</div>
          </Box>
        </Box>
      </TetherPortal>
    </>
  )
}

export const ScatterPlot = ({ data }) => {
  const lineIndexes = [...Array(5).keys()]

  return (
    <div className={cx(styles.container)}>
      {data.map(({ dataPoint, description, area }, index) => {
        return (
          <Dot
            key={index}
            x={dataPoint[0]}
            y={dataPoint[1]}
            area={area}
            description={description}
          />
        )
      })}
      <div className={styles.horizontalLines}>
        {lineIndexes.map(index => (
          <div
            key={index}
            className={cx(styles.horizontalLine, {
              [styles.axis]: index === lineIndexes.length - 1,
            })}
          ></div>
        ))}
      </div>
      <div className={styles.verticalLines}>
        {lineIndexes.map(index => (
          <div key={index} className={cx(styles.verticalLine)}></div>
        ))}
      </div>
      <div className={styles.markers}>
        {lineIndexes.map(index => (
          <div key={index} className={cx(styles.marker)}></div>
        ))}
      </div>
      <div className={styles.verticalSteps}>
        <div className={styles.verticalLabel}>{t`Interest match`}</div>
        {lineIndexes.map(index => (
          <div key={index} className={cx(styles.verticalStep)}>
            {index * 25}
          </div>
        ))}
      </div>
      <div className={styles.horizontalSteps}>
        <div className={styles.horizontalLabel}>{t`Personality match`}</div>
        {lineIndexes.map(index => (
          <div key={index} className={cx(styles.horizontalStep)}>{`${100 -
            index * 25}`}</div>
        ))}
      </div>
    </div>
  )
}
